export class DialogModelUploadCreditBillError {
    constructor(
      public errorList: any,
      public message: String
    ) {}
  }